<template>
  <the-section v-if="data.subscription_order_item" :title="$t('ec-line014.cart.subscriptionId', { id: data.index })">
    <template slot="sub">
      <div
        v-if="isPaymentError && !isLumpsum"
        class="text-red-150 text-base font-normal lg:mx-6 mt-2 whitespace-pre-wrap"
      >
        <p>
          {{
            $t('ec-line014.cart.error.messagePayment', {
              delivery_date: this.Utils.date.getDateString(this.data.next_delivery_date, this.Constants.FORMAT_DATE),
            })
          }}
        </p>
        <p v-if="!isNDDGreaterThan9DateFromToday">{{ $t('ec-line014.cart.error.messageDeliveryIsCompleting') }}</p>
      </div>
    </template>
    <div class="cart-subscription-item-list">
      <div class="cart-subscription-item-list__body">
        <cart-subscription-item
          v-for="item in data.subscription_order_item"
          :key="item.id"
          :data="item"
          :disable-button="isNotUpdateSubscription"
        ></cart-subscription-item>
        <div class="cart-subscription-item-list__total">
          <p>
            <span class="flex items-center">
              <i18n path="common.cart.formatLabel" class="flex items-center">
                <template #label>
                  <span>{{ $t('common.label.subtotal') }}</span>
                </template>
                <template #tax>
                  <span class="tax-font">{{ $t('common.cart.withTax') }}</span>
                </template>
              </i18n>
              <el-popover
                class="ml-2"
                :tabindex="2"
                placement="top"
                title=""
                width="200"
                trigger="hover"
                :content="$t('common.cart.subtotalExplanation')"
              >
                <span slot="reference">
                  <img :src="require('@/assets/images/help-round-icon.svg')" alt="" />
                </span>
              </el-popover>
            </span>
            <i18n path="common.cart.formatPrice">
              <template #price>
                <span>{{ subtotal.toLocaleString() }}</span>
              </template>
              <template #unit>
                <span class="text-xxs">{{ $t('common.cart.yen') }}</span>
              </template>
            </i18n>
          </p>
          <p v-if="subdiscount < 0" class="text-xs">
            <i18n path="common.cart.formatLabel">
              <template #label>
                <span class="font-light">{{ $t('common.label.priceDiscount') }}</span>
              </template>
            </i18n>
            <i18n path="common.cart.formatPrice" class="text-red">
              <template #price>
                <span>{{ '(' + subdiscount.toLocaleString() }}</span>
              </template>
              <template #unit>
                <span class="text-xxs">{{ $t('common.cart.yen') + ')' }}</span>
              </template>
            </i18n>
          </p>
          <p v-if="user && user.rank_name && subdiscount < 0 && user.rank_use_flag" class="text-xs text-red">
            <i18n path="common.messages.rankDiscount">
              <template #rankMember>{{ $t(user.rank_name) }}</template>
            </i18n>
          </p>
          <p>
            <i18n path="common.cart.formatLabel" class="flex items-center">
              <template #label>
                <span>{{ $t('common.label.deliveryFee') }}</span>
              </template>
              <template #tax>
                <span class="tax-font">{{ $t('common.cart.withTax') }}</span>
              </template>
            </i18n>
            <i18n path="common.cart.formatPrice">
              <template #price>
                <span>{{ deliveryFee.toLocaleString() }}</span>
              </template>
              <template #unit>
                <span class="text-xxs">{{ $t('common.cart.yen') }}</span>
              </template>
            </i18n>
          </p>
          <p class="font-bold">
            <i18n path="common.cart.formatLabel" class="flex items-center">
              <template #label>
                <span>{{ $t('common.label.total') }}</span>
              </template>
              <template #tax>
                <span class="tax-font">{{ $t('common.cart.withTax') }}</span>
              </template>
            </i18n>
            <i18n path="common.cart.formatPrice">
              <template #price>
                <span>{{ total.toLocaleString() }}</span>
              </template>
              <template #unit>
                <span class="text-xxs">{{ $t('common.cart.yen') }}</span>
              </template>
            </i18n>
          </p>
          <p class="text-xs">
            <i18n path="common.cart.formatLabel">
              <template #label>
                <span class="font-light">{{ $t('common.label.tax') }}</span>
              </template>
            </i18n>
            <i18n path="common.cart.formatPrice">
              <template #price>
                <span>{{ '(' + taxTotal.toLocaleString() }}</span>
              </template>
              <template #unit>
                <span class="text-xxs">{{ $t('common.cart.yen') + ')' }}</span>
              </template>
            </i18n>
          </p>
          <hr class="mt-2 mb-2" />
          <p class="font-medium">
            <span class="min-w-max mr-2">{{ $t('common.label.deliveryPattern') }}</span>
            <span>{{ subscriptionPattern }}</span>
          </p>
          <p class="font-medium">
            <span class="min-w-max mr-2">{{ $t('common.label.deliveryTimezone') }}</span>
            <span>{{ data.delivery_time }}</span>
          </p>
          <p v-if="isPauseTab" class="font-medium">
            <span class="min-w-max mr-2">{{ $t('common.label.stopDate') }}</span>
            <span>{{ Utils.date.getDateString(data.pause_date, Constants.FORMAT_DATE) }}</span>
          </p>
          <template v-else>
            <p class="font-medium">
              <span class="min-w-max mr-2">{{ $t('common.label.nextDeliveryDate') }}</span>
              <span>{{ Utils.date.getDateString(data.next_delivery_date, Constants.FORMAT_DATE) }}</span>
            </p>
            <p class="font-medium">
              <span class="min-w-max mr-2">{{ $t('common.label.nextNextDelieveryDate') }}</span>
              <span>{{ Utils.date.getDateString(data.next_next_delivery_date, Constants.FORMAT_DATE) }}</span>
            </p>
          </template>

          <el-button
            v-if="isLumpsumAndNotPauseTab"
            class="cart-subscription-item-list__total__button mt-2 font-normal"
            size="mini"
            @click="showDeliveryDialog"
            >{{ $t('ec-line014.lumpsum.shopInfo.checkDeliveryDate') }}</el-button
          >
        </div>
        <p
          class="whitespace-pre-line text-base text-red-150 mt-2 lg:mt-3"
          v-if="isLumpsumAndNotPauseTab && isPaymentError"
        >
          {{
            $t('ec-line009.subscriptionList.errormessagePayment', {
              date: Utils.date.getDateString(data.next_delivery_date, Constants.FORMAT_DATE),
            })
          }}
        </p>
        <inquiry-information v-if="isLumpsum" class="mt-5 mb-2.5" :is-pause-tab="isPauseTab" />
        <div class="cart-subscription-item-list__action" :class="[isShowButtonCancelOrPause ? '' : 'pb-0']">
          <el-button
            v-if="!isLumpsum"
            class="submit-btn font-bold text-base lg:text-lg leading-normal"
            @click="handleSubmit(data.subscription_status_id)"
            >{{
              data.subscription_status_id === Constants.SUBSCRIPTION_STATUS.PAUSE
                ? $t('ec-line009.reopenButton')
                : isPaymentError && !isNDDGreaterThan9DateFromToday
                ? $t('ec-line014.cart.changePaymentBtn')
                : $t('ec-line009.subscriptionList.changePurchaseBtn')
            }}
          </el-button>
        </div>
      </div>
      <p
        v-if="isShowButtonCancelOrPause"
        class="cart-subscription-item-list__link-to-pause-section"
        @click="toDetailPage(Constants.LIST_SECTION.PAUSE_SECTION)"
      >
        {{ buttonCancelOrPauseText }}
      </p>
    </div>
    <el-dialog
      :visible="lumpsumDeliveryVisible"
      class="cart-subscription-item-list__delivery__dialog"
      v-loading="lumpsumLoading"
      fullscreen
      append-to-body
      destroy-on-close
      :show-close="false"
    >
      <my-page-layout>
        <div class="cart-subscription-item-list__delivery__dialog__content mx-4 mt-8 lg:mt-12">
          <div class="flex justify-between items-baseline">
            <h3>
              {{ $t('ec-line014.lumpsum.deliveryDialog.title', [data.index]) }}
            </h3>
            <div
              class="cart-subscription-item-list__delivery__dialog__content__close-button"
              @click="closeDeliveryDialog"
            >
              <img :src="require('@/assets/images/close-button.svg')" />
            </div>
          </div>

          <el-card class="cart-subscription-item-list__delivery__dialog__content__card" shadow="never">
            <div class="cart-subscription-item-list__delivery__dialog__content__card__body beauty-scrollbar">
              <el-row
                :gutter="24"
                v-for="(lumpsumDelivery, i) in lumpsumDeliveryData"
                :key="i"
                class="mt-7 flex items-center"
              >
                <el-col :span="12">
                  <p class="text-h4 text-right">
                    {{ $t('ec-line014.lumpsum.deliveryDialog.time', [i + 1]) }}
                  </p>
                </el-col>
                <el-col :span="12">
                  <p class="text-body-02 text-left">{{ $d(lumpsumDelivery.delivery_date, 'short') }}</p>
                </el-col>
              </el-row>
            </div>
          </el-card>
          <div class="w-full mt-6 pb-6 flex justify-center">
            <el-button class="cancel-btn align-center text-base lg:text-lg" @click="closeDeliveryDialog">{{
              $t('common.action.cancel')
            }}</el-button>
          </div>
        </div>
      </my-page-layout>
    </el-dialog>
  </the-section>
</template>

<script>
import CartSubscriptionItem from './CartSubscriptionItem.vue'
import TheSection from '@/components/my-page-partials/TheSection.vue'
import { SubscriptionService } from '@/services'
import MyPageLayout from '@/layouts/MyPageLayout.vue'
import { REDIRECT_LINE015_FLAG } from '@/constants'
import InquiryInformation from '@/components/ec-line009/InquiryInformation.vue'
import { add, isAfter, startOfDay } from 'date-fns'

export default {
  components: {
    CartSubscriptionItem,
    TheSection,
    MyPageLayout,
    InquiryInformation,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    tab: {
      type: String,
      default: () => '',
    },
  },

  data() {
    return {
      lumpsumDeliveryVisible: false,
      lumpsumLoading: false,
      lumpsumDeliveryData: [],
    }
  },

  computed: {
    shop() {
      return this.$store.getters['auth/shop']
    },
    isPauseTab() {
      return this.tab === this.Constants.EC_LINE009.TABS_TYPE.PAUSED
    },
    pauseAndCancelFlag() {
      const { cancellation_flag, pause_flag } = this.$store.state.auth.shop
      return cancellation_flag && pause_flag
    },
    onlyCancelFlag() {
      const { cancellation_flag, pause_flag } = this.$store.state.auth.shop
      return cancellation_flag && !pause_flag
    },
    notPauseAndCancelFlag() {
      const { cancellation_flag, pause_flag } = this.$store.state.auth.shop
      return !cancellation_flag && !pause_flag
    },
    isShowButtonCancelOrPause() {
      return !this.isPauseTab && !this.notPauseAndCancelFlag
    },
    buttonCancelOrPauseText() {
      if (this.isLumpsum) {
        return ''
      }
      return this.pauseAndCancelFlag
        ? this.$t('ec-line014.action.pauseAndCancelSubscription')
        : this.onlyCancelFlag
        ? this.$t('ec-line014.action.cancelSubscription')
        : this.$t('ec-line014.action.pauseSubscription')
    },
    subtotal() {
      return Number(this.data.summary.next_subtotal)
    },
    subdiscount() {
      return Number(this.data.summary.next_discount_amount_total)
    },
    total() {
      return Number(this.data.summary.next_payment_total)
    },
    deliveryFee() {
      return Number(this.data.summary.next_delivery_fee)
    },
    taxTotal() {
      return Number(this.data.summary.next_tax_total)
    },
    subscriptionPattern() {
      const dayOfWeeks = Object.entries(this.Constants.DAY_OF_WEEK).map(([key, val]) => ({
        value: val,
        label: this.$t(`common.dayOfWeek.${this.$_.camelCase(key)}`),
      }))

      const text = {
        [this.Constants.DELIVERY_PATTERN_CHANGE.MONTHLY_DATE_SPECIFICATION]: this.$t(
          'ec-line014.cart.deliveryPatternInterval.monthlyDateSpecification',
          {
            param1: this.data.param1,
            param2: this.data.param2,
          }
        ),
        [this.Constants.DELIVERY_PATTERN_CHANGE.INTERVAL_DESIGNATION]: this.$t(
          'ec-line014.cart.deliveryPatternInterval.intervalDesignation',
          {
            param1: this.data.param1,
            param2: this.$t('common.weekNo', { week: this.data.param2 }),
            param3: dayOfWeeks.find((i) => i.value === this.data.param3)?.label || '',
          }
        ),
        [this.Constants.DELIVERY_PATTERN_CHANGE.SPECIFY_DELIVERY_DATE_INTERVAL]: this.$t(
          'ec-line014.cart.deliveryPatternInterval.specifyDeliveryDateInterval',
          { param1: this.data.param1 }
        ),
      }

      return text[this.data.subscription_division_id]
    },
    isLumpsum() {
      return this.data.lump_sum_payment_flag
    },
    isLumpsumAndNotPauseTab() {
      return !this.isPauseTab && this.isLumpsum
    },
    isNotUpdateSubscription() {
      return this.isLumpsumAndNotPauseTab || this.data.disable_next_delivery || this.data.is_has_order_unship_last
    },
    isPaymentError() {
      return !!this.data.code
    },
    isNDDGreaterThan9DateFromToday() {
      return isAfter(this.data.next_delivery_date, add(startOfDay(new Date()), 9))
    },
  },
  methods: {
    handleSubmit(subscriptionStatus) {
      if (subscriptionStatus === this.Constants.SUBSCRIPTION_STATUS.PAUSE) {
        this.$emit('to-detail', {
          id: this.data.id,
          section: this.Constants.LIST_SECTION.SUBSCRIPTION_SECTION,
          index: this.data.index,
          redirectReason: REDIRECT_LINE015_FLAG.REDIRECT,
        })

        return
      }

      if (this.isPaymentError && (!this.isNDDGreaterThan9DateFromToday || this.isLumpsumAndNotPauseTab)) {
        this.toCpayPage()
        return
      }

      this.toDetailPage(this.isPaymentError ? this.Constants.LIST_SECTION.PAYMENT_SECTION : undefined)
    },
    toCpayPage() {
      window.open(`/lpc/cpay?code=${this.data.code}`, '_blank')
    },
    toDetailPage(section) {
      if (this.isLumpsumAndNotPauseTab) return
      this.$emit('to-detail', {
        id: this.data.id,
        section,
        index: this.data.index,
        redirectReason: REDIRECT_LINE015_FLAG.REDIRECT,
      })
    },
    showDeliveryDialog() {
      this.lumpsumDeliveryVisible = true
      this.fetchLumpsumDeliveryDate()
    },
    closeDeliveryDialog() {
      this.lumpsumDeliveryVisible = false
    },
    fetchLumpsumDeliveryDate() {
      if (!this.data.id) {
        this.closeDeliveryDialog()
        return
      }

      this.lumpsumLoading = true

      SubscriptionService.getLumpsumDeliverydate(this.data.id)
        .then(({ data }) => (this.lumpsumDeliveryData = data))
        .finally(() => (this.lumpsumLoading = false))
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/css/components/ec-line014/cart-subscription-item-list.scss';
</style>
